import {DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {CouponTypeObject, CouponTypes, stampa_id} from "./SanPellegrino";
import {getDateYear} from "../../Utility/DateUtility";
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {forkJoin} from "rxjs";
import {map} from "rxjs/operators";
import {Zone} from "../../BaseEnvironments/Klimaitalia";
import {VerticalSidebarComponent} from "../../../app/layouts/vertical-sidebar/vertical-sidebar.component";
import {GetEmailInvioCoupon} from "./assegnazioneClienti";
function campoCustom(nome: string, valore:((coupon,parent?)=>string )| string, show?:(x,permission)=>boolean): CampoAggiuntivo {
  return {
    nome: nome, oggetti: ["prezzo"], type: 'html', hideif:{func:show}, func: (coupon, parent?) => [typeof valore == "string" ? valore : valore(coupon,parent)]
  }
}

export function MapNewCliente(company: any, api: ApiPathsService, bup?:any, component?:DynamicCrudService){
  company.lingua = 'IT'
  company.nazione = 'ITA'
  company.catCont = 'ITA'
  company.listinoBase = 'BASE'
  company.iva = 22;
  if(company.tipi?.includes(2) || company.tipi?.includes(50)) {
    company.grOutput = '001'
  }
  if(company?.provinciaObject){
    company.zona = Zone?.find(x=> x.provinciaObject?.id == company.provinciaObject?.id )?.id;
    company.regione = company.provinciaObject?.regione_id;
  }
  company.pagamento = 38;
  return {
    ...company,
    ruoli: ["C"],

  }
}

function AssegnazioneCrud(){
  var OBJ: OggettoConfig = {
    Id: 'assegna-cliente',

    campi:[
      CampoAggiuntivo.SingleDropdown("Coupon","coup", '/prodotti/list','label',{
        responseHasData: true,
        url:'/prodotti/list',
        parameter: [{nome: "page", value: 0}, {nome: "size", value: 10}, {nome: 'tipo', value: 50}],
        responseMap: (response, permission, oggetto)=>{ return response.filter(x=> !x.video).map(x=> {
          return {...x, label: `${x.correlatiObject.reduce((a,c)=>`${a} ${c.prodotto}`,'')} - ${CouponTypeObject(x).label}`}
        })}

      } ,
      'col-lg-12',
      ()=>true,
      {
        singleOutput: false,
        singleSelection: false,
        allowSearchFilter:true,
      }),
      CampoAggiuntivo.InputField("Invia Email ", "send", "checkbox", "col-lg-12"),
      campoCustom("", (coupon) => "Verrà allegata all'email il coupon e la scheda prodotto in formato PDF", (x)=>x.send)
    ],
    customSave : (x: any, api: ApiPathsService, callback: (x: any) => void, bup?: any, toastrService?: ToastrService)=>{

      const gets = x.coupObject.map(coupon => {
        return api.ClassicPost("/prodotti/get", coupon).pipe(map(x => {
          return  x
        }));
      })

      forkJoin(gets).subscribe((results: any[]) => {
        const requests = results.map(coupon => {
          const email = {
            id: coupon.id,
            cliente: x.cliente_id,
            subject: x.send? `Coupon Sanpellegrino` : undefined,
            body: x.send? GetEmailInvioCoupon(coupon) : undefined,
            stampa: x.send? stampa_id(coupon) : undefined,
            email: x.clienteObject.email,
            nominativo: x.clienteObject.nominativo,
          }


          return api.ClassicPost("/prodotti/coupon/send", {...email}).pipe(map(x => {
            return {data: x, voce: coupon}
          }));
        }
        );
        forkJoin(requests).subscribe((results: { data: any[], voce: any }[]) => {
          if(callback)
          callback(results);
        });
      });


    }
  }
  return OBJ
}

export function CreateCustomer(campiModificati, api, callback){

  const _cliente = campiModificati?.id ? campiModificati: MapNewCliente(campiModificati, api);
  api.ClassicPost(`/anagrafica/clienti/${campiModificati.id ? 'update' : 'add'}`, _cliente ).subscribe(cliente => {
    var campiCliente: { id: string, label:string }[] = [{id:"email", label:"Email"}, {id:"nominativo", label:"Nominativo"}, {id:"piva", label:"Partita IVA"}];
    var campiCambiati = campiCliente.filter(x=>cliente[x.id] != campiModificati[x.id]);
    if(campiCambiati.length && !confirm(`È stata individuata un’anagrafica già registrata nella nostra piattaforma; tuttavia, i dati inseriti non risultano coerenti con quelli presenti a sistema.\n
            \n
            Di seguito sono riportate le discrepanze rilevate:\n
            ${campiCambiati.map(x => `${x.label}: ${cliente[x.id]} (valore inserito: ${campiModificati[x.id]})`).join("\n")}\n

            Si desidera procedere comunque con l’operazione?\n
            In alternativa, si invita a contattare il servizio di assistenza Klimaitalia alla mail: info@klimaitalia.it `)){

      return;
    }
    if(callback)
      callback(cliente);
  });
}

function ClientiAgenti() {
  var OBJ: OggettoConfig = {
    Id: "clienti-agenti",
    MenuItems:[
      {
        path: "/sanpellegrino/shared/dynamiclist/clienti-agenti",
        title: "Clienti",
        icon: "fa-regular fa-user",
        class: "",
        capacita: [],
        ruoliOperativi:["AG","NAM"],
        show:(component: VerticalSidebarComponent)=>component.permission.isntAccessRoles([19]),
      },
    ],
    RestRoute: "/anagrafica/clienti",
    ListDefaultFilter: {tipo: 50},
    ListResponseHasData: true,
    listTitle: "Clienti",
    HasAddList: {},
    NoSaveEdit:true,    //OnSaveMap: (x) => MapNewCliente,
    customSave:(campiModificati, api: ApiPathsService, callback, bup,toastrService:ToastrService) =>{
      if(!campiModificati.email || !campiModificati.nominativo ) {
        toastrService.error("I campi Email e nominativo sono richiesti.");
        return;
      }
      CreateCustomer(campiModificati, api, callback);

    },

    Headers: [
      CampoAggiuntivo.InputField("Nominativo", "nominativo", "text", "", {modificabile: false, printable:true}),
      CampoAggiuntivo.InputField("Email", "email", "email", "", {modificabile: false, printable:true}),
      CampoAggiuntivo.InputField("Partita IVA", "piva", "text", "", {modificabile: false, printable:true}),
    ],
    campi:[
      CampoAggiuntivo.InputField("Nominativo", "nominativo", "text", "col-lg-3", {modificabile: true, printable:true, disabledif:{fieldexist:'id'}}),
      CampoAggiuntivo.InputField("Email", "email", "email", "col-lg-3", {modificabile: true, printable:true, disabledif:{fieldexist:'id'}}),
      CampoAggiuntivo.InputField("Partita IVA", "piva", "text", "col-lg-3", {modificabile: true, printable:true, disabledif:{fieldexist:'id'}}),
      CampoAggiuntivo.TableField("Coupon Assegnati",
        [
          campoCustom("Lotto",(coupon) =>getDateYear(coupon.dataScadenza1)?.toString()),
          CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "", {modificabile: false}),
          campoCustom("Stato", (coupon) =>  {
            if(coupon.statoCoupon)//spedito)
              return coupon.statoCoupon;
            if(false)//pagato)
              return "Pagato";
            if(false)//bonifico segnalato)
              return "Bonifico Segnalato";
            if(coupon.cliente || coupon.video)
              return "Assegnato a PV";
            if(coupon.agenteCoupon)
              return "Assegnato ad Agente";
            if(coupon.dmCoupon)
              return "Assegnato a DM";
            if( coupon.namCoupon)
              return "Assegnato al NAM"
            return "DA ASSEGNARE";
          }),
          campoCustom("Prodotto", (coupon)=>coupon.correlatiObject.reduce((a,c)=>`${a} ${c.prodotto}`,'')),
          campoCustom("Danneggiato", (coupon)=>coupon.danneggiato ),
          campoCustom("Sostituito", (coupon)=>coupon.sostituito ),
          campoCustom("Data Assegnazione", (coupon) => coupon?.dataAssegnazione)
        ],'coupon',true,'col-lg-12',{
        url: '/prodotti/list',
        responseHasData: true,
          hideif:{func:(cli)=>cli.id},
        parameter: [{nome: "page", value: 0}, {nome: "size", value: 10}, {nome: 'tipo', value: 50}],
          responseMap:(resp, x,y)=>{return resp.filter(x=>x.clienteObject?.id==y.id)},
          azioni:[
            {
              nome: 'Scarica coupon',
              close: false,
              icon: 'fa-solid fa-download text-info',
              class: ' btn p-0',
              labelClass: 'text-info ',
              type: 'func',
              tooltip: "Scarica il file del coupon",
              func:( x, bottone, campo, Oggetto, api: ApiPathsService)=>{
                api.ClassicPost("/prodotti/get", x).subscribe(coupon=>{
                  api.FilePost("/prodotti/coupon/print", {id: x.id, stampa: stampa_id(coupon)}).subscribe((data)=>{
                    api.downloadService.downloadFile(data)
                  })
                })

                //api.DownloadFileByID()
              }
            },
            {
              nome: 'Stampa coupon',
              close: false,
              icon: 'fa-solid fa-print text-info',
              class: ' btn p-0',
              labelClass: 'text-info ',
              type: 'func',
              tooltip: "Stampa il PDF del coupon",
              func:(x, bottone, campo, Oggetto, api:ApiPathsService)=>{
                api.ClassicPost("/prodotti/get", x).subscribe(coupon=>{
                  api.FilePost("/prodotti/coupon/print", {id: x.id, stampa: stampa_id(coupon)}).subscribe((data)=>{
                    api.downloadService.printFile(data)
                  })
                })
              }
            },
            {
              nome: 'Invia Email',
              close: false,
              icon: 'fa-regular fa-paper-plane text-info',
              class: ' btn p-0',
              labelClass: 'text-info ',
              type: 'func',
              tooltip: "Invia email con il coupon e la scheda prodotto in formato PDF",
              func:( x, bottone, campo, Oggetto, api: ApiPathsService)=>{
                api.ClassicPost("/prodotti/get", x).subscribe(coupon=>{
                  const email = {
                    id: coupon.id,
                    cliente: coupon.cliente,
                    subject:  `Coupon Sanpellegrino` ,
                    body: GetEmailInvioCoupon(coupon),
                    stampa: stampa_id(coupon) ,
                    email: coupon.video,
                    nominativo: coupon.clienteObject.nominativo,
                  }
                  api.ClassicPost("/prodotti/coupon/send", {...email}).subscribe(data=>{

                  })
                })

                //api.DownloadFileByID()
              }
            },
          ],
        Buttons:[

          {
            type:'edit',
            CrudSettings: AssegnazioneCrud(),
            campi: AssegnazioneCrud().campi,
            icon: 'fas fa-plus text-info',
            tooltip: 'Assegna',
            nome: 'Assegna',
            class: ' btn ',
            labelClass: 'ml-1 text-info font-weight-bold',
            placeholder: '',
            item:(x,component)=>{
              return {cliente_id: x.id, clienteObject: x}
            }



          }
          ]
      })
    ]
  }
  return OBJ;
}


export var ClientiAgentiEnv = () => {
  var env: any = {
    Modules: {
      "ClientiAgenti": true
    },
    Cruds: [ClientiAgenti()],
    Menu: [...ClientiAgenti().MenuItems]
  }
  return env;

}
